import type { WordCollection } from "../collection.types";

export const springEquinoxCollection: WordCollection = {
  id: "spring-equinox",
  title: "Spring Equinox (Ostara)",
  icon: "weather-sunny",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 2, 18), // March 18th
  endDate: new Date(new Date().getFullYear(), 2, 23), // March 23rd
  words: [
    "balance",
    "bloom",
    "breath",
    "butterfly",
    "ceremony",
    "dawn",
    "energy",
    "flame",
    "flower",
    "gold",
    "harmony",
    "honey",
    "lime",
    "mint",
    "mother",
    "nectar",
    "nest",
    "pollen",
    "power",
    "purple",
    "rabbit",
    "rain",
    "root",
    "seed",
    "shadow",
    "silver",
    "soil",
    "spark",
    "stream",
    "sweet",
    "unity",
    "water",
    "wind",
    "yellow",
  ],
};
